export default __webpack_public_path__ + "static/media/hero.e6f4e7e5.png";